import React, { memo } from 'react'

interface SearchIconProps {
  className?: string
  size?: number
}

const RoundedWarningIcon: React.FC<SearchIconProps> = memo(
  ({ className = '', size = 16 }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.89022 15.37C5.86147 15.79 6.89925 16 8.00354 16C9.10785 16 10.1467 15.7892 11.12 15.3675C12.0933 14.9459 12.94 14.3737 13.66 13.6509C14.38 12.9281 14.95 12.081 15.37 11.1098C15.79 10.1385 16 9.10075 16 7.99646C16 6.89215 15.79 5.85333 15.37 4.88C14.95 3.90667 14.38 3.06 13.66 2.34C12.94 1.62 12.094 1.05 11.1221 0.63C10.1502 0.21 9.11173 0 8.00666 0C6.90161 0 5.86312 0.21 4.8912 0.63C3.91929 1.05 3.07111 1.62 2.34666 2.34C1.62222 3.06 1.05 3.90596 0.63 4.87788C0.21 5.84979 0 6.88827 0 7.99334C0 9.09839 0.21 10.1369 0.63 11.1088C1.05 12.0807 1.62222 12.9289 2.34666 13.6533C3.07111 14.3778 3.91897 14.95 4.89022 15.37ZM7 5C7 4.44772 7.44772 4 8 4C8.55229 4 9 4.44772 9 5V8C9 8.55229 8.55229 9 8 9C7.44772 9 7 8.55229 7 8V5ZM9 11.0667C9 11.6189 8.55229 12.0667 8 12.0667C7.44772 12.0667 7 11.6189 7 11.0667C7 10.5144 7.44772 10.0667 8 10.0667C8.55229 10.0667 9 10.5144 9 11.0667Z"
      />
    </svg>
  ),
)

export { RoundedWarningIcon }
